import { useMemo } from 'react'

import { useInfiniteQuery } from '@tanstack/react-query'

import { SearchOffersDto } from '@wwt/entities/api/search-response'
import { Offer, OffersAndMetadata } from '@wwt/entities/search-response'
import { searchRequestAdapterForRemote } from '@wwt/shared/utils/adapters'

import {
	SEARCH_SLATE_TIME,
	SearchRequest,
	searchOptions,
	useSearchAPIStore
} from '@/entities/search'

import { filterCurrentOffer } from '../utils'

export const useOtherRooms = (offer: Offer | null) => {
	const searchRequestState = useSearchAPIStore.use.searchRequest()

	/**
	 * Add to search request info offer integration name and hotel id
	 */
	const searchRequestBody = useMemo((): SearchRequest | null => {
		if (!offer || !searchRequestState) {
			return null
		}

		return {
			...searchRequestState,
			integrationsSearch: [
				{
					integrationName: offer.IDs.integrationName,
					hotels: [
						{
							hotelId: offer.IDs.integrationHotelId
						}
					]
				}
			]
		}
	}, [offer, searchRequestState])

	/**
	 * Transform {@link SearchRequest} to {@link SearchOffersDto}
	 */
	const searchRequestBodyForAPI = useMemo(() => {
		if (searchRequestBody === null) {
			return null
		}

		return searchRequestAdapterForRemote(searchRequestBody)
	}, [searchRequestBody])

	/**
	 * We cannot use `useSearch` hook here because it independent search request
	 */
	const searchResponse = useInfiniteQuery<OffersAndMetadata>(
		searchOptions(searchRequestBodyForAPI as SearchOffersDto, {
			enabled: searchRequestBodyForAPI != null,
			staleTime: SEARCH_SLATE_TIME
		})
	)

	return {
		...filterCurrentOffer(
			searchResponse,
			offer?.IDs.integrationHotelId,
			offer?.IDs.integrationRoomId
		),
		// eslint-disable-next-line @tanstack/query/no-rest-destructuring
		...searchResponse
	}
}
